
import { database } from "../../firebase";
import moment from "moment";
export const storeAchivements = (uid, type, achivements) => {
    if (type === 'Achievement') {
        return database.ref("achievements/").child(uid).push({
            uid: uid,
            type: type,
            month: achivements.month,
            year: achivements.year,
            description: achivements.description,
            title: achivements.title,
            sourceUrl: achivements.sourceUrl,
            timestamp: moment().toDate().getTime(),
            isDeleted: false,
        });
    }

    else if (type === 'Award') {
        return database.ref("achievements/").child(uid).push({
            uid: uid,
            type: type,
            month: achivements.month,
            year: achivements.year,
            description: achivements.description,
            title: achivements.title,
            issuer: achivements.issuer,
            sourceUrl: achivements.sourceUrl,
            timestamp: moment().toDate().getTime(),
            isDeleted: false,
        });

    }
    else {
        return database.ref("achievements/").child(uid).push({
            uid: uid,
            type: type,
            title: achivements.title,
            presstitle: achivements.presstitle,
            month: achivements.month,
            year: achivements.year,
            author: achivements.author,
            sourceUrl: achivements.sourceUrl,
            description: achivements.description,
            timestamp: moment().toDate().getTime(),
            isDeleted: false,
        });
    }
}